export const API_FUNCTIONS = process.env.REACT_APP_API_FUNCTIONS;
